<template>
  <div class="con-wrap">
    <!-- <div class="usually-tool">
      <p class="tool-title">常用工具</p>
      <div class="tool-box">
        <dl>
          <dt>
            <a
              :href="url"
              target="_blank"
              class="icons iconfont icon-reimburse-query"
            ></a>
          </dt>
          <dd>
            <p class="cost-Reimbursement">费用报销</p>
          </dd>
        </dl>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    }
  },
  created() {
    this.url = "http://baidu.com"
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
// .con-wrap {
//   height: 100%;
//   margin: 0;
//   padding: 20px;
//   background-color: #f8f8f8;
// }
.con-wrap {
  margin: 20px;
  background-color: #fff;
}
.usually-tool {
  margin-top: 20px;
  .tool-title {
    width: 100%;
    height: 20px;
    padding-left: 10px;
    margin-bottom: 10px;
    border-left: 3px solid #0093ff;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .tool-box {
    width: 100%;
    background: #fff;
    padding-top: 16px;
    dl {
      display: inline-block;
      width: 64px;
      height: 90px;
      margin-left: 24px;
      margin-bottom: 14px;
    }
    dd {
      margin-top: 10px;
    }
  }
  .icons {
    display: inline-block;
    width: 64px;
    height: 64px;
    text-align: center;
    font-size: 64px;
    color: #3396fc;
  }
  .cost-Reimbursement {
    text-align: center;
    line-height: 14px;
    font-family: "Microsoft YaHei";
    font-size: 14px;
    color: #333;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
}
</style>
